import { useFocusEffect } from '@react-navigation/native'
import { Href, router, useGlobalSearchParams, useNavigation } from 'expo-router'
import { useCallback } from 'react'

export const useRouterCanGoBackParam = (): boolean => {
    const { canGoBack } = useGlobalSearchParams<{ canGoBack?: 'true' }>()

    return !!canGoBack
}

export const useRouteBackToParam = (): Href | undefined => {
    const { backTo } = useGlobalSearchParams<{ backTo?: string }>()

    return backTo as Href
}

export const useRouterCanGoBackParamSubscriber = () => {
    const { canGoBack } = useGlobalSearchParams<{ canGoBack?: 'true'; backTo?: string }>()

    const navigation = useNavigation()

    useFocusEffect(
        useCallback(() => {
            if (canGoBack) return

            const unsubscribeState = navigation.addListener('state', () => {
                router.setParams({ canGoBack: 'true' })
            })

            const unsubscribeBeforeRemove = navigation.addListener('beforeRemove', () => {
                router.setParams({ canGoBack: undefined, backTo: undefined })
            })

            return () => {
                unsubscribeState()
                unsubscribeBeforeRemove()
            }
        }, [canGoBack, navigation])
    )
}
